<div id="orderresult" class="ya-typography">
  <div class="ya-page-content ya-page-content--padding ya-page-content--webshop">
    <ng-container *ngIf="checkoutpaymentmodel">
      <ng-container [ngSwitch]="checkoutpaymentmodel.done">
        <ng-container *ngSwitchCase="ResponseCode_Done.Authorised">
          <div class="inline-icon margin-down" inlineSVG="shop-icons.svg#ya-hypersoft-bestellen-bestaetigung2"></div>
          <ng-container *ngIf="isMandatoryPayment then mandatoryPaymentResult else defaultResult"></ng-container>
          <ng-template #mandatoryPaymentResult>
            <div class="title margin-down" langkey="phInHouseOrderResult_Mandatory_Payment_Header"></div>
            <div class="text margin-down" [innerHTML]="orderConfirmInfo"></div>
            <ng-container *ngIf="!hasPosTableNumberQrCodeSvg">
              <div class="text margin-down">{{odreConfirmSubText}}</div>
            </ng-container>
            <ng-container *ngIf="hasPosTableNumberQrCodeSvg">
              <div class="text margin-down" langkey="phInHouseOrderResult_Mandatory_Payment_PayAtWaiter"></div>
              <qr-code-display [qrData]="posTableNumberQrCodeSvg" [trigger$]="(qrCodeVisible$)" [autoActivate]="false"
                [animate]="true"></qr-code-display>
            </ng-container>
          </ng-template>
          <ng-template #defaultResult>
            <div class="title margin-down" langkey="phInHouseOrderResult_ThankYouForYourVisit"></div>
            <div class="text margin-down" langkey="phInHouseOrderResult_SuccessfullPayment"></div>
            <div class="text margin-down" langkey="phInHouseOrderResult_SuccessfullPayment_SecondParagraph"></div>
          </ng-template>
          <ng-container *ngIf="!isGroupOrder">
            <ng-container *ngIf="hasOpenItems">
              <div class="text margin-down" [innerHTML]="openItems"></div>
            </ng-container>
          </ng-container>
          <div class="ya-webshop-button-container">
            <ng-container *ngIf="showToNoCOOBtn">
              <button mat-flat-button (click)="gotoNoCOO()">
                <span langkey="phInHouseOrderResult_ToNoCOO"></span>
              </button>
            </ng-container>
            <ng-container *ngIf="isGroupOrder; then returnToGroupBtn else returnToTableBtn"></ng-container>
            <ng-template #returnToGroupBtn>
              <ng-container *ngIf="showInHauseLandingPageBtn">
                <button mat-flat-button (click)="openInHauseLandingPage()">
                  <span langkey="phGroupOrder_PaymentResult_GroupBtn"></span>
                </button>
              </ng-container>
            </ng-template>
            <ng-template #returnToTableBtn>
              <ng-container *ngIf="showInHauseLandingPageBtn">
                <button mat-flat-button (click)="openInHauseLandingPage()">
                  <span langkey="phInHouseOrderResult_ToTable"></span>
                </button>
              </ng-container>
            </ng-template>
            <ng-container *ngIf="showReturnToHomeBtn">
              <button mat-flat-button (click)="gotoHome()">
                <span langkey="phInHouseOrderResult_ToTheHomescreen"></span>
              </button>
            </ng-container>
          </div>
          <ng-container *ngFor="let bonuspointsHtmlRow of bonuspointsHtmlRows">
            <div class="bonuspoints" [innerHTML]="bonuspointsHtmlRow"></div>
          </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="ResponseCode_Done.Cancelled">
          <div class="title margin-down" langkey="phInHouseOrderResult_PaymentCouldNotBeAccepted"></div>
          <div class="text margin-down" langkey="phInHouseOrderResult_ThereWasAProblem_TEXT"></div>
          <div class="ya-webshop-button-container">
            <button mat-flat-button (click)="returnToPayment()">
              <span langkey="phOrderResult_ReturnToCheckout"></span>
            </button>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="ResponseCode_Done.Error">
          <ng-container *ngTemplateOutlet="Error"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="ResponseCode_Done.Refused">
          <ng-container *ngTemplateOutlet="Error"></ng-container>
        </ng-container>
        <ng-template #Error>
          <div class="title margin-down" langkey="phInHouseOrderResult_PaymentCouldNotBeAccepted"></div>
          <div class="text margin-down" langkey="phInHouseOrderResult_ThereWasAProblem_TEXT"></div>
          <div class="ya-webshop-button-container">
            <button mat-flat-button (click)="returnToPayment()">
              <span langkey="phOrderResult_ReturnToCheckout"></span>
            </button>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>
  </div>
</div>